import { render, staticRenderFns } from "./chart.vue?vue&type=template&id=1f98c096&scoped=true&"
import script from "./chart.vue?vue&type=script&lang=ts&"
export * from "./chart.vue?vue&type=script&lang=ts&"
import style0 from "./chart.vue?vue&type=style&index=0&id=1f98c096&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f98c096",
  null
  
)

export default component.exports